var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowGreenStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3L22.5257 8.47432L28 10.5L22.5257 12.5257L20.5 18L18.4743 12.5257L13 10.5L18.4743 8.47432L20.5 3Z",
    fill: "#5CE7A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03514 0L6.39508 3.67519L10.0703 5.03514L6.39508 6.39508L5.03514 10.0703L3.67519 6.39508L0 5.03514L3.67519 3.67519L5.03514 0Z",
    fill: "#F6DB68"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGreenStar);
export default __webpack_public_path__ + "static/media/yellow-green-star.bf7c53473bfb25d4bf844cd2421abdc2.svg";
export { ForwardRef as ReactComponent };